import { createFileRoute, redirect } from '@tanstack/react-router';
import { MenuTitle, RouterContext } from '../../../types';

export const instagramHashtagAnalyticsStaticData = { menuTitle: MenuTitle.Instagram };

export const Route = createFileRoute('/_private-routes/hashtag-analytics/instagram')({
  staticData: instagramHashtagAnalyticsStaticData
});

// Common used for IG, Tiktok routes
const SUPPORTED_LOCAL_TEAMS = ['th', 'id', 'vn', 'my', 'ph', 'sg', 'hk', 'tw'];

export const saveCountryIdBeforeLoad =
  (redirectParams: Parameters<typeof redirect>[0]) =>
  ({ params, context }: { context: RouterContext; params: { countryId: string } }) => {
    if (!params.countryId || !SUPPORTED_LOCAL_TEAMS.includes(params.countryId)) {
      context.setHashtagAnalyticsCountryId('');
      return redirect(redirectParams);
    } else if (context.hashtagAnalyticsCountryId !== params.countryId) {
      context.setHashtagAnalyticsCountryId(params.countryId);
    }
  };

const hashtagCountryIdRoutes = [
  '/hashtag-analytics/instagram/$countryId',
  '/hashtag-analytics/tiktok/hashtag/$countryId',
  '/hashtag-analytics/tiktok/keyword/$countryId'
] as const satisfies Parameters<typeof redirect>[0]['to'][];

export const checkCountryIdBeforeLoad =
  (to: (typeof hashtagCountryIdRoutes)[number]) =>
  ({ context }: { context: RouterContext }) => {
    if (context.hashtagAnalyticsCountryId) {
      return redirect({
        to,
        params: { countryId: context.hashtagAnalyticsCountryId }
      });
    }
  };
